import { Redirect } from 'expo-router';

/** Keep existing invitation deep links inside the unified owner management surface. */
export default function InvitationsRedirect() {
  return <Redirect href="/dashboard/drivers" />;
}
